import React, { useContext, useEffect, useState, memo, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';

import ProductsTable from '../../organisms/productsTable/view';
import SellModule from '../../organisms/sellModule/view';
import CustomBox from '../../atoms/container/container';
import ButtonGroup from '../../molecules/buttonGroup/view';
import Resolution from '../../organisms/resolution/resolution';
import { useCarrito } from '../../../context/carrito/context';
import { roleContext } from '../../../context/role/context';
import { listener } from '../../../utils/dispatch';
import BuyPayMethods from '../../organisms/payBuyMethods/view';
import BuyFromXml from '../../organisms/buyfromxml/view';
import NewProduct from '../../organisms/newProduct/view';
import TabSwitcher from '../../molecules/TabSwitcher/view';
import SpendTable from '../../organisms/SpendTable/view';
import NewSpend from '../../organisms/NewSpend/view';
import SpendFromXml from '../../organisms/SpendFromXml/view';
import { useAskPrice } from '../../atoms/prompt/price';
import { useUpdateCarItem } from '../../atoms/prompt/caritem';
import ListCompras from '../../organisms/listCompras/view';
import SupportDocumentsTable from '../../organisms/SupportDocumentsTable/view';

import { createBuy, createBuyWithSupportDocument } from '../../../usecases/buys-usecase';
import { handleUpdateCartItem } from './controller';

const PurchaseView = memo(({ profile, removeItem, car, update, taxGroup, tercero, total, onSubmitAction }) => (
    <Row className="g-4 align-items-stretch">
        <Col md={6}>
            <CustomBox style={{ height: '100%', padding: 'var(--spacing-md)' }}>
                <ProductsTable profile={profile} type="buy" />
            </CustomBox>
        </Col>
        <Col md={6}>
            <CustomBox style={{ height: '100%', padding: 0, border: 'none', background: 'transparent' }}>
                <SellModule
                    removeItems={removeItem}
                    car={car}
                    update={update}
                    taxGroup={taxGroup}
                    tercero={tercero}
                    total={total}
                    type="buy"
                >
                    <BuyPayMethods onSubmit={onSubmitAction} />
                </SellModule>
            </CustomBox>
        </Col>
    </Row>
));

import { useOnboardingTour } from '../../../hooks/useOnboardingTour';

function Compras() {
    useOnboardingTour();

    const { profile } = useContext(roleContext);

    const [activeTabIndex, setActiveTabIndex] = useState(window.location.hash === '#spend' ? 1 : 0);
    const [terceros, setTerceros] = useState([]);
    const { PriceModalComponent } = useAskPrice();
    const { askUpdateCarItem, UpdateCarItemModalComponent } = useUpdateCarItem();

    // Context and Cart hooks
    const { car, taxGroup, total, addItem, removeItem, updateItem: updateCartItem, cloneItem: cloneCartItem, setType } = useCarrito();
    const [tercero, SetTercero] = useState(undefined);

    useEffect(() => {
        const cleanThird = listener('btn-thirds-add', (e) => SetTercero(e.detail.data));
        const cleanAdd = listener('btn-add-product', (e) => addItem(e.detail.data));
        const cleanClone = listener('btn-clone-product', (e) => cloneCartItem(e.detail.data, e.detail.data.buy_value));
        const cleanCancel = listener("cancel-transaction", () => SetTercero(undefined));
        const cleanGoToBuyTab = listener("go-to-buy-tab", () => setActiveTabIndex(3));

        // Set cart type to "buy" for purchase operations
        setType("buy");

        return () => {
            cleanThird();
            cleanAdd();
            cleanClone();
            cleanCancel();
            cleanGoToBuyTab();
        };
    }, [addItem, cloneCartItem, setType]);

    useEffect(() => { setTerceros(terceros) }, [terceros]);

    const update = useCallback(async (item) => {
        await handleUpdateCartItem(item, askUpdateCarItem, updateCartItem);
    }, [askUpdateCarItem, updateCartItem]);

    const handleUnifiedBuy = useCallback(async (buyData, isSupportDoc) => {
        if (isSupportDoc) {
            return await createBuyWithSupportDocument(buyData);
        }
        return await createBuy(buyData);
    }, []);

    const pageTab = [
        {
            name: "Compras",
            component: () => (
                <CustomBox style={{ padding: 'var(--spacing-md)', height: '85%' }}>
                    <ListCompras profile={profile} />
                </CustomBox>
            )
        },
        {
            name: "Gastos",
            component: () => (
                <CustomBox style={{ padding: 'var(--spacing-md)', height: '85%' }}>
                    <SpendTable />
                </CustomBox>
            )
        },
        {
            name: "Documentos Soporte",
            component: () => (
                <CustomBox style={{ padding: 'var(--spacing-md)', height: '85%' }}>
                    <SupportDocumentsTable />
                </CustomBox>
            )
        },
        {
            name: "Nueva Compra",
            component: () => (
                <PurchaseView
                    profile={profile}
                    removeItem={removeItem}
                    car={car}
                    update={update}
                    taxGroup={taxGroup}
                    tercero={tercero}
                    total={total}
                    onSubmitAction={handleUnifiedBuy}
                />
            )
        }
    ];

    return (
        <>
            {PriceModalComponent}
            {UpdateCarItemModalComponent}
            <Resolution />

            <ButtonGroup
                title="Compras y Gastos"
                description="Registra tus facturas de compra, gastos y documentos soporte."
            >
                {
                    (activeTabIndex === 0 || activeTabIndex === 3) && (
                        <>
                            <NewProduct
                                id="products-page-buy"
                                profile={profile}
                            />
                            <BuyFromXml profile={profile} />
                        </>
                    )
                }
                {
                    activeTabIndex === 1 && (
                        <>
                            <NewSpend></NewSpend>
                            <SpendFromXml profile={profile} />
                        </>
                    )
                }
            </ButtonGroup>
            <TabSwitcher tabs={pageTab} onTabChange={setActiveTabIndex} activeTabIndex={activeTabIndex} hashKey="tab"></TabSwitcher>
        </>
    );
}

export default Compras;
